
export const API_BASE_URL: string = "https://api.sty.re"